import { maxCharacters } from './constants';

export const deriveQuizCardText = (questionNumber: number, questionText: string): string =>
    `Q${questionNumber}. ${questionText.slice(0, 80)}${
        questionText.length > maxCharacters ? '...' : ''
    }`;
